import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Modal,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import api from "../utils/api";
import { toast, ToastContainer } from "react-toastify";

const baseURL = process.env.REACT_APP_BASE_URL;

const KeywordsForm = ({ render, setRender }) => {
  const [keywords, setKeywords] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(""); // Default blank → backend will assign General
  const ToasterToggle = JSON.parse(localStorage.getItem("Toaster"));

  // ---------------- FETCH CATEGORIES ----------------
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get(`${baseURL}keyword-category/all`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        setCategories(response.data);
      } catch (error) {
        console.error("Failed to fetch categories", error);
      }
    };
    fetchCategories();
  }, []);

  // ---------------- SUBMIT ----------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const keywordsArray = keywords
      .split(",")
      .map((kw) => kw.trim())
      .filter(Boolean);

    try {
      const response = await api.post(
        `${baseURL}keyword/create-keywords`,
        {
          keywords: keywordsArray,
          categoryId: selectedCategoryId || null, // <-- send null if blank (goes to General)
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (ToasterToggle) {
        toast.success(response.data.message, {
          position: "top-center",
          autoClose: 1500,
        });
      }

      setKeywords("");
      setSelectedCategoryId("");
      setRender(!render);
      setModalOpen(false);
    } catch (error) {
      console.error("Failed to submit keywords", error);
      if (ToasterToggle) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      }
    }

    setIsSubmitting(false);
  };

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  return (
    <Box style={{ color: "white", textAlign: "center" }}>
      <Button
        variant="contained"
        onClick={handleOpenModal}
        sx={{
          backgroundColor: "#15178e",
          color: "white",
          "&:hover": { backgroundColor: "#0d0d55", color: "white" },
        }}
      >
        Create Keyword
      </Button>

      {/* Modal */}
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
        aria-labelledby="create-keyword-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 420,
            bgcolor: "background.paper",
            p: 4,
            borderRadius: 1,
            color: "black",
          }}
        >
          <Typography variant="h6">Create Keywords</Typography>

          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            <TextField
              fullWidth
              label="Enter Keywords (comma-separated)"
              value={keywords}
              onChange={(e) => setKeywords(e.target.value)}
              required
              InputLabelProps={{ style: { color: "black" } }}
              InputProps={{ style: { color: "black" } }}
              sx={{ mb: 2 }}
            />

            <FormControl fullWidth>
              <InputLabel>Select Category (optional)</InputLabel>
              <Select
                value={selectedCategoryId}
                label="Select Category"
                onChange={(e) => setSelectedCategoryId(e.target.value)}
              >
                <MenuItem value="">General (Default)</MenuItem>

                {categories.map((cat) => (
                  <MenuItem key={cat._id} value={cat._id}>
                    {cat.categoryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  mt: 3,
                  width: "50%",
                  backgroundColor: "#15178e",
                  color: "white",
                  "&:hover": { backgroundColor: "#0d0d55" },
                }}
                disabled={isSubmitting}
              >
                Submit
              </Button>
            </div>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default KeywordsForm;
